export enum EcosystemCategory {
  FEATURED = 'Featured',
  AI = 'AI',
  DEFI = 'Defi',
  COMPUTE = 'Compute',
  CONSUMER = 'Consumer',
}

export const ECOSYSTEM_PROJECTS = [
  {
    title: 'Dreamcash',
    subtitle: 'Founded by Beam',
    description:
      'Dreamcash is a consumer trading app built on Hyperliquid, offering perpetual futures, spot tokens, and equity markets with up to 40x leverage across mobile, web, and desktop. The Beam Foundation incubated Dreamcash from concept to launch, supporting product development, branding, and go-to-market strategy. Through its own HIP-3 markets (CASH), Dreamcash now lets users trade assets like TSLA, GOLD, and the USA500 on-chain with USDT collateral.',
    image: '/images/apps/dreamcash.png',
    href: 'https://dreamcash.xyz/',
    categories: [EcosystemCategory.FEATURED, EcosystemCategory.DEFI],
  },
  {
    title: 'Beam Ventures',
    subtitle: 'Built by Beam',
    description:
      'Beam Ventures is a frontier technology fund based in Abu Dhabi Global Market, licensed to manage a Qualified Investor Fund focused on web3, AI, gaming, and finance. It backs high-conviction founders at the earliest stages, while its Booster accelerator provides mentorship and incubation support. The fund aims to establish Abu Dhabi as a global hub for the next generation of frontier-tech companies.',
    image: '/images/apps/ventures.png',
    href: 'https://beamventures.com/',
    categories: [EcosystemCategory.FEATURED, EcosystemCategory.AI],
  },
  {
    title: 'Aethir',
    subtitle: 'Backed by Beam',
    description: `Aethir operates a decentralized GPU cloud network spanning 435,000+ containers across 90+ countries, serving both AI and gaming workloads. It is one of the largest positions in the Beam Foundation treasury and a key partner across the ecosystem's compute and DePIN initiatives. Through its enterprise layer Axe Compute (NASDAQ: AGPU), Aethir is bridging decentralized infrastructure with real commercial demand backed by SLAs.`,
    image: '/images/apps/aethir.png',
    href: 'https://aethir.com/',
    categories: [
      EcosystemCategory.FEATURED,
      EcosystemCategory.AI,
      EcosystemCategory.COMPUTE,
    ],
  },
  {
    title: 'Tactical Compute',
    subtitle: 'Joint venture',
    description: `Tactical Compute (TACOM) is a $40M joint venture between Aethir, Beam, and USDai, operating out of Abu Dhabi Global Markets. It provides targeted exposure to the Crypto x AI vertical through hardware financing, yield arbitrage, and early network bootstrapping. For the Beam Foundation, TACOM represents a direct bridge between the ecosystem's treasury and the rapidly growing demand for decentralized compute.`,
    image: '/images/apps/tactical.png',
    href: 'https://www.tacticalcompute.ai/',
    categories: [
      EcosystemCategory.FEATURED,
      EcosystemCategory.AI,
      EcosystemCategory.COMPUTE,
    ],
  },
  {
    title: 'TrialXtreme',
    subtitle: 'Partnered with Beam',
    description:
      'Trial Xtreme Freedom is a mobile racing game developed by Gameplay Galaxy, with over 2 million downloads and 40 million races completed during soft launch. The Beam Foundation works closely with the team to integrate blockchain elements while maintaining a gaming-first, web3-second philosophy. A global launch with full Web3 features is on the horizon.',
    image: '/images/apps/tx.png',
    href: 'https://www.trialxtreme.xyz/',
    categories: [EcosystemCategory.FEATURED, EcosystemCategory.CONSUMER],
  },
  {
    title: 'Sophon',
    subtitle: 'Incubated by Beam',
    description:
      'Sophon is a ZK Stack blockchain purpose-built for consumer entertainment, offering gasless transactions, social login, and a built-in distribution layer for apps. The Beam Foundation supported Sophon in its early stages from initial concept to the launch, before Sophon became fully independent. The two ecosystems continue to collaborate, with shared infrastructure through Guardian Node memberships and overlapping communities.',
    image: '/images/apps/sophon.png',
    href: 'https://sophon.xyz/',
    categories: [EcosystemCategory.FEATURED, EcosystemCategory.CONSUMER],
  },
  {
    title: 'Noon',
    subtitle: 'Partnered with Beam',
    description: `Noon is a yield-generating stablecoin protocol building USN, designed to be the most intelligent and fair stablecoin in the industry, using delta-neutral strategies to maximize returns for holders. The Beam Foundation collaborated closely on in the early stages, and Noon's incubator DCLM runs Beam Nodes while deploying treasury assets on-chain. Noon represents the ecosystem's push into DeFi infrastructure with a strong community-first ethos.`,
    image: '/images/apps/noon.png',
    href: 'https://noon.capital/',
    categories: [EcosystemCategory.FEATURED, EcosystemCategory.DEFI],
  },
];
